/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsContainerV2: {
  name: 'container-v2';
  data: string;
} = {
  name: 'container-v2',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5v-1.99a.57.57 0 0 0 0-.019V2A1.5 1.5 0 0 0 14 .5H2Zm-.5 12V14a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-1.5h-13Zm11.617-1H1.5V4.862L13.117 11.5ZM14.5 2v1.5h-13V2a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5Zm0 2.5H2.883L14.5 11.138V4.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
